import type { List } from 'mdast';
import type { State } from '../state';

export function list(state: State, node: List): void {
	// If the schema has a taskList node and ALL items are task items (checked !== null/undefined),
	// use taskList instead of bullet_list.
	//
	// Note: mixed lists (some checked, some not) fall through to bullet_list. This is intentional
	// — GFM allows mixed task/regular items in a single list, but ADF taskList requires all items
	// to be taskItems. A future enhancement could split mixed lists, but for now the simpler
	// behaviour (all-or-nothing) is safer and avoids invalid PM documents.
	const taskListType = state.schema.nodes.taskList ?? state.schema.nodes.task_list;
	if (
		!node.ordered &&
		taskListType &&
		node.children.length > 0 &&
		node.children.every((item) => item.checked !== null && item.checked !== undefined)
	) {
		state.openNode(taskListType);
		state.parseTokens(node.children);
		state.closeNode();
		return;
	}

	const nodeType = node.ordered
		? (state.schema.nodes.ordered_list ?? state.schema.nodes.orderedList)
		: (state.schema.nodes.bullet_list ?? state.schema.nodes.bulletList);

	if (!nodeType) {
		// Gracefully degrade: schema has no list node — render children directly as block content
		state.parseTokens(node.children);
		return;
	}

	const attrs = node.ordered ? { order: node.start ?? 1 } : null;
	state.openNode(nodeType, attrs);
	state.parseTokens(node.children);
	state.closeNode();
}
